import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EntityComponent } from './entity.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModuleMobi } from '../material/material.module';
import { AppPermissionsPipe, SharedModule } from 'shared-library';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { WorkflowComponent } from './components/workflow/workflow.component';



@NgModule({
  declarations: [
    EntityComponent,
    WorkflowComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModuleMobi,
     SharedModule,
     ScrollingModule,
     AppPermissionsPipe
  ],
  exports: [
    EntityComponent
  ],
})
export class EntityModule { }
